(() => {
  const cfg = window.PITB_ENTRY_FEE;
  if (!cfg) return;

  const VARIANT_ID = String(cfg.variantId || '');
  const HANDLE = cfg.handle || 'tff-sg-popup-2026';
  const TICKET_HANDLE = cfg.ticketHandle || HANDLE;
  const LEGACY_HANDLE = cfg.legacyHandle || 'pitb-sg-popup-entry-fee';
  const PROPERTIES = {
    _pitb_entry_fee: 'required',
    Note: cfg.label || 'The First Fan SG Popup Entry Fee',
  };

  const normalizeSlotKey = (value) => {
    const raw = String(value || '').trim();
    if (!raw) return '';
    return raw.replace(/-/g, '–').replace(/\s+/g, ' ');
  };

  const parseClock12 = (part) => {
    const m = String(part || '')
      .trim()
      .match(/^(\d{1,2}):(\d{2})\s*(AM|PM)?$/i);
    if (!m) return '';
    let hour = Number(m[1]);
    const minute = m[2];
    const ap = (m[3] || '').toUpperCase();
    if (ap === 'AM') {
      if (hour === 12) hour = 0;
    } else if (ap === 'PM' && hour !== 12) {
      hour += 12;
    }
    return `${String(hour).padStart(2, '0')}:${minute}`;
  };

  const toSlotKey = (raw) => {
    const s = String(raw || '').trim();
    if (!s) return '';
    const parts = s.split(/\s*[–-]\s*/).map((part) => part.trim()).filter(Boolean);
    if (parts.length >= 2) {
      const start = parseClock12(parts[0]);
      const end = parseClock12(parts[parts.length - 1]);
      if (start && end) return `${start}–${end}`;
    }
    return s.replace(/-/g, '–').replace(/\s+/g, ' ');
  };

  const ticketSpotBySlot = cfg.ticketSpotBySlot || {};
  const ticketSpotByKey = cfg.ticketSpotByKey || {};
  const isoByDateLabel = cfg.isoByDateLabel || {};

  const normalizeDate = (value) => {
    const raw = String(value || '').trim();
    if (!raw) return '';
    if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) return raw;
    return isoByDateLabel[raw] || raw;
  };

  const ticketKey = (date, slot) => {
    const iso = normalizeDate(date);
    const key = toSlotKey(slot) || normalizeSlotKey(slot);
    if (!iso || !key) return '';
    return `${iso}|${key}`;
  };

  const currentPickupDate = (cart) => {
    if (window.PITBBooking && typeof window.PITBBooking.current === 'function') {
      const fromUi = normalizeDate(window.PITBBooking.current().pitb_pickup_date);
      if (fromUi) return fromUi;
    }
    const attrs = (cart && cart.attributes) || {};
    return normalizeDate(attrs.pitb_pickup_date || attrs['Pickup date'] || '');
  };

  const variantIdForSlot = (slot, date) => {
    const key = toSlotKey(slot) || normalizeSlotKey(slot);
    const iso = normalizeDate(date || currentPickupDate());
    const liveMap =
      (window.PITB_ENTRY_FEE && window.PITB_ENTRY_FEE.ticketSpotByKey) || ticketSpotByKey;
    const composite = ticketKey(iso, key);
    const mapped =
      (composite && liveMap[composite]) ||
      ticketSpotBySlot[composite] ||
      ticketSpotBySlot[key] ||
      ticketSpotBySlot[key.replace(/–/g, '-')];
    if (mapped) return String(mapped);
    return '';
  };

  const selfCollectTicketSpotByKey = () =>
    (window.PITB_BOOKING_CATALOG &&
      window.PITB_BOOKING_CATALOG.self_collect &&
      window.PITB_BOOKING_CATALOG.self_collect.ticketSpotByKey) ||
    {};

  const variantIdForSelfCollectSlot = (slot, date) => {
    const key = toSlotKey(slot) || normalizeSlotKey(slot);
    const iso = normalizeDate(date || currentPickupDate());
    const composite = ticketKey(iso, key);
    const mapped = composite && selfCollectTicketSpotByKey()[composite];
    return mapped ? String(mapped) : '';
  };

  const currentSlot = (cart) => {
    if (window.PITBBooking && typeof window.PITBBooking.current === 'function') {
      const fromUi = normalizeSlotKey(window.PITBBooking.current().pitb_timeslot);
      if (fromUi) return fromUi;
    }
    const attrs = (cart && cart.attributes) || {};
    return normalizeSlotKey(attrs.pitb_timeslot || attrs['Pickup timeslot'] || '');
  };

  const withJs = (url, fallback) => String(url || fallback).replace(/\.js$/i, '') + '.js';
  const routes = {
    cart: (window.routes && window.routes.cart_url) || '/cart',
    add: withJs(window.routes && window.routes.cart_add_url, '/cart/add'),
    change: withJs(window.routes && window.routes.cart_change_url, '/cart/change'),
  };
  const orderGate = window.PITB_ORDER_CAP || {};
  // Closed = Disable purchases OR orders > cap
  const isCloseState = () =>
    Boolean(orderGate && (orderGate.closeState || orderGate.fullyBooked));

  const disableAddToCartWhenClosed = () => {
    if (!isCloseState()) return;
    document
      .querySelectorAll(
        'product-form [name="add"], form[action*="/cart/add"] [name="add"], .pitb-pc__atc, .pitb-pdp__atc:not(.pitb-pdp__atc--soldout)'
      )
      .forEach((btn) => {
        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('is-disabled');
      });
  };

  let syncing = false;
  let pendingSync = null;
  let syncChain = Promise.resolve();
  let lastKnownCart = null;

  const readAttendees = () => 1;

  const updateFeeQtyLabels = (qty) => {
    document.querySelectorAll('.pitb-entry-fee-lock__qty').forEach((el) => {
      el.textContent = `Qty ${qty}`;
    });
  };

  const refreshCartUi = async () => {
    try {
      const sectionIds = ['cart-icon-bubble'];
      const mainCartItems = document.getElementById('main-cart-items');
      const mainCartFooter = document.getElementById('main-cart-footer');
      if (mainCartItems) sectionIds.push('main-cart-items');
      if (mainCartFooter) sectionIds.push('main-cart-footer');

      const res = await fetch(`${routes.cart}?sections=${sectionIds.join(',')}`, {
        credentials: 'same-origin',
      });
      if (!res.ok) {
        if (mainCartItems) window.location.reload();
        return;
      }
      const sections = await res.json();

      if (mainCartItems && sections['main-cart-items']) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(sections['main-cart-items'], 'text/html');
        const nextItems = doc.querySelector('.js-contents');
        const currentItems = mainCartItems.querySelector('.js-contents');
        if (nextItems && currentItems) currentItems.innerHTML = nextItems.innerHTML;

        const nextHidden = doc.querySelector('[data-pitb-entry-fee-state]');
        const currentHidden = document.querySelector('[data-pitb-entry-fee-state]');
        if (nextHidden && currentHidden) currentHidden.innerHTML = nextHidden.innerHTML;

        const nextTotals = doc.querySelector('[data-pitb-cart-totals]');
        const currentTotals = document.querySelector('[data-pitb-cart-totals]');
        if (nextTotals && currentTotals) currentTotals.innerHTML = nextTotals.innerHTML;

        const nextPage = doc.querySelector('[data-pitb-cart-page]');
        const currentPage = document.querySelector('[data-pitb-cart-page]');
        if (nextPage && currentPage) {
          const nextCollection = nextPage.getAttribute('data-pitb-collection') || 'event';
          currentPage.setAttribute('data-pitb-collection', nextCollection);
          const catalog = nextPage.getAttribute('data-pitb-entry-fee-catalog');
          if (catalog != null) currentPage.setAttribute('data-pitb-entry-fee-catalog', catalog);
          syncEstimatedTotals(nextCollection);
        }
      }

      if (mainCartFooter && sections['main-cart-footer']) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(sections['main-cart-footer'], 'text/html');
        const nextFooter = doc.querySelector('.js-contents');
        const currentFooter = mainCartFooter.querySelector('.js-contents');
        if (nextFooter && currentFooter) currentFooter.innerHTML = nextFooter.innerHTML;
      }

      if (sections['cart-icon-bubble']) {
        const bubble = document.getElementById('cart-icon-bubble');
        if (bubble) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
          bubble.innerHTML = doc.body.innerHTML;
        }
      }

    } catch (_) {
      hideFeeLoading();
      if (document.getElementById('main-cart-items')) window.location.reload();
    }
  };

  const feeLineEls = () => Array.from(document.querySelectorAll('[data-pitb-entry-fee-line]'));
  const cartTotalsEls = () => Array.from(document.querySelectorAll('[data-pitb-cart-totals]'));
  const cartItemContainers = () =>
    [document.getElementById('main-cart-items'), document.getElementById('CartDrawer-CartItems')].filter(Boolean);
  const checkoutButtons = () =>
    Array.from(document.querySelectorAll('#checkout, #CartDrawer-Checkout, button[name="checkout"].cart__checkout-button'));

  const parseMoneyToCents = (text) => {
    const raw = String(text || '').replace(/,/g, '').match(/(\d+(?:\.\d+)?)/);
    if (!raw) return 0;
    return Math.round(Number(raw[1]) * 100);
  };

  const formatMoneySgd = (cents) => `${(Math.max(0, Number(cents) || 0) / 100).toFixed(2)} SGD`;

  const catalogFeeCents = () => {
    const page = document.querySelector('[data-pitb-cart-page]');
    const fromPage = Number(page && page.getAttribute('data-pitb-entry-fee-catalog'));
    if (Number.isFinite(fromPage) && fromPage > 0) return fromPage;
    const price = Number(cfg.ticketPrice);
    if (Number.isFinite(price) && price > 0) return Math.round(price * 100);
    return 0;
  };

  /**
   * Visit: show entry-fee estimate in totals immediately (no date/slot needed).
   * Self-collect: remove fee from totals immediately.
   */
  const syncEstimatedTotals = (method) => {
    const page = document.querySelector('[data-pitb-cart-page]');
    const summary = document.querySelector('[data-pitb-cart-totals]');
    if (!summary) return;

    const nextMethod = method === 'self_collect' ? 'self_collect' : 'event';
    if (page) page.setAttribute('data-pitb-collection', nextMethod);

    const subtotalEl = summary.querySelector('[data-pitb-subtotal]');
    const feeEl = summary.querySelector('[data-pitb-entry-fee-amount]');
    const totalEl = summary.querySelector('[data-pitb-estimated-total]');
    const detailEl = summary.querySelector('[data-pitb-entry-detail]');
    if (!subtotalEl || !feeEl || !totalEl) return;

    const subtotalCents = parseMoneyToCents(subtotalEl.textContent);
    let feeCents = 0;

    if (nextMethod === 'event') {
      const liveFee = parseMoneyToCents(feeEl.textContent);
      const hasFeeLine = Boolean(document.querySelector('[data-pitb-entry-fee-line]'));
      feeCents = hasFeeLine && liveFee > 0 ? liveFee : catalogFeeCents();
      if (!hasFeeLine && detailEl) detailEl.textContent = '';
    } else {
      feeCents = 0;
      if (detailEl) detailEl.textContent = '';
    }

    feeEl.textContent = formatMoneySgd(feeCents);
    totalEl.textContent = formatMoneySgd(subtotalCents + feeCents);
  };

  let checkoutLoadingDepth = 0;

  const setCheckoutLoading = (on) => {
    if (on) checkoutLoadingDepth += 1;
    else checkoutLoadingDepth = Math.max(0, checkoutLoadingDepth - 1);

    const navigating =
      window.PITBCheckoutAuth &&
      typeof window.PITBCheckoutAuth.isNavigating === 'function' &&
      window.PITBCheckoutAuth.isNavigating();
    const busy = checkoutLoadingDepth > 0 || navigating;

    checkoutButtons().forEach((btn) => {
      btn.classList.toggle('loading', busy);
      btn.setAttribute('aria-busy', busy ? 'true' : 'false');
      const spinner = btn.querySelector('.loading__spinner');
      if (spinner) spinner.classList.toggle('hidden', !busy);
      if (busy) {
        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
      } else {
        btn.removeAttribute('aria-busy');
        if (window.PITBBooking && typeof window.PITBBooking.syncCheckoutGate === 'function') {
          window.PITBBooking.syncCheckoutGate();
        }
      }
    });
  };

  const setFeeLoading = (on) => {
    feeLineEls().forEach((row) => {
      row.classList.toggle('is-updating', Boolean(on));
      row.setAttribute('aria-busy', on ? 'true' : 'false');
      row.querySelectorAll('.loading__spinner').forEach((el) => {
        el.classList.toggle('hidden', !on);
      });
    });

    cartTotalsEls().forEach((totals) => {
      totals.classList.toggle('is-updating', Boolean(on));
      totals.setAttribute('aria-busy', on ? 'true' : 'false');
      totals.querySelectorAll('.loading__spinner').forEach((el) => {
        el.classList.toggle('hidden', !on);
      });
    });

    cartItemContainers().forEach((container) => {
      container.classList.toggle('cart__items--disabled', Boolean(on));
    });

    const footer = document.getElementById('main-cart-footer');
    if (footer) footer.classList.toggle('is-updating', Boolean(on));

    const drawerFooter = document.querySelector('.cart-drawer__footer');
    if (drawerFooter) drawerFooter.classList.toggle('is-updating', Boolean(on));

    setCheckoutLoading(on);
  };

  const hideFeeLoading = () => setFeeLoading(false);

  const syncSlotForms = () => {
    const slot = currentSlot();
    const date = currentPickupDate();
    const targetId = variantIdForSlot(slot, date);
    const remaining =
      window.PITBBooking && typeof window.PITBBooking.remainingForSlot === 'function'
        ? window.PITBBooking.remainingForSlot(date, slot)
        : 1;
    const blocked = isCloseState() || !date || !slot || remaining <= 0;

    document.querySelectorAll('product-form[data-pitb-entry] .product-variant-id').forEach((input) => {
      if (targetId) input.value = targetId;
    });

    document.querySelectorAll('product-form[data-pitb-entry] [name="add"]').forEach((btn) => {
      btn.disabled = blocked;
      btn.setAttribute('aria-disabled', blocked ? 'true' : 'false');
      if (!date) btn.removeAttribute('title');
      else if (!slot) btn.setAttribute('title', 'Select a pickup timeslot to add the entry pass.');
      else if (remaining <= 0) btn.setAttribute('title', 'That timeslot is fully booked. Choose another available slot.');
      else btn.removeAttribute('title');
    });
  };

  const fetchCart = async () => {
    const res = await fetch(`${routes.cart}.js`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });
    if (!res.ok) throw new Error('cart fetch failed');
    lastKnownCart = await res.json();
    if (window.PITBBooking && typeof window.PITBBooking.noteCart === 'function') {
      window.PITBBooking.noteCart(lastKnownCart);
    }
    return lastKnownCart;
  };

  const SELF_COLLECT_HANDLE = String(cfg.selfCollectHandle || '').toLowerCase();
  const selfCollectVariantIds = () =>
    Object.values(
      (window.PITB_BOOKING_CATALOG &&
        window.PITB_BOOKING_CATALOG.self_collect &&
        window.PITB_BOOKING_CATALOG.self_collect.ticketSpotByKey) ||
        {}
    ).map(String);

  const isSelfCollectItem = (item) => {
    if (!item) return false;
    const handle = String(item.handle || item.product_handle || '').toLowerCase();
    const variantId = String(item.variant_id || '');
    if (SELF_COLLECT_HANDLE && handle === SELF_COLLECT_HANDLE) return true;
    if (selfCollectVariantIds().includes(variantId)) return true;
    return handle.includes('self-collect-only');
  };

  const eventTicketVariants = () =>
    Object.values(
      (window.PITB_BOOKING_CATALOG &&
        window.PITB_BOOKING_CATALOG.event &&
        window.PITB_BOOKING_CATALOG.event.ticketSpotByKey) ||
        ticketSpotByKey
    ).map(String);

  const isFeeItem = (item) => {
    if (!item) return false;
    const handle = String(item.handle || item.product_handle || '').toLowerCase();
    const title = String(item.product_title || item.title || '').toLowerCase();
    const sku = String(item.sku || '');
    const variantId = String(item.variant_id || '');
    if (SELF_COLLECT_HANDLE && handle === SELF_COLLECT_HANDLE) return false;
    const ticketVariants = eventTicketVariants();
    return (
      (VARIANT_ID && variantId === VARIANT_ID) ||
      ticketVariants.includes(variantId) ||
      handle === HANDLE.toLowerCase() ||
      handle === TICKET_HANDLE.toLowerCase() ||
      handle === LEGACY_HANDLE.toLowerCase() ||
      handle.includes('entry-fee') ||
      handle.includes('popup-24-sep') ||
      sku.indexOf('TS-') === 0 &&
        (handle === HANDLE.toLowerCase() ||
          handle === TICKET_HANDLE.toLowerCase() ||
          eventTicketVariants().includes(variantId)) ||
      (item.properties && item.properties._pitb_entry_fee === 'required') ||
      /entry fee/i.test(title) ||
      /entry pass/i.test(title) ||
      /pitb sg popup/i.test(title) ||
      /popup entry/i.test(title)
    );
  };

  const visibleCartCount = (cart) => {
    const items = (cart && cart.items) || [];
    return items.filter((item) => !isFeeItem(item) && !isSelfCollectItem(item)).length;
  };

  const syncVisibleCartCount = async (cart) => {
    try {
      const data = cart || (await fetchCart());
      const count = visibleCartCount(data);
      const hasMerch = count > 0;

      document.querySelectorAll('[data-pitb-cart-count]').forEach((el) => {
        el.textContent = `(${count})`;
      });

      document.querySelectorAll('[data-pitb-cart-btn]').forEach((btn) => {
        btn.hidden = false;
        btn.classList.toggle('is-empty', !hasMerch);
      });

      document.querySelectorAll('[data-pitb-cart-fab]').forEach((fab) => {
        fab.hidden = false;
        fab.classList.toggle('is-empty', !hasMerch);

        const link = fab.querySelector('.pitb-cart-fab');
        if (link) link.classList.toggle('is-empty', !hasMerch);

        const label = fab.querySelector('[data-pitb-cart-label]');
        if (label) label.textContent = 'Cart';

        /* Figma cart btn uses inline CART (n) — keep any legacy bubble hidden */
        fab.querySelectorAll('.cart-count-bubble').forEach((bubble) => {
          bubble.hidden = true;
          bubble.style.display = 'none';
        });
      });

      document.querySelectorAll('[data-pitb-cart-totals]').forEach((summary) => {
        summary.hidden = !hasMerch;
        summary.classList.toggle('is-empty', !hasMerch);
        const checkoutBtn = summary.querySelector('[name="checkout"], #checkout');
        if (checkoutBtn && window.PITBBooking && typeof window.PITBBooking.syncCheckoutGate === 'function') {
          window.PITBBooking.syncCheckoutGate();
        } else if (checkoutBtn) {
          checkoutBtn.disabled = !hasMerch;
        }
      });

      document.querySelectorAll('[data-pitb-entry-banner]').forEach((banner) => {
        banner.hidden = !hasMerch;
      });

      document.querySelectorAll('[data-pitb-booking]').forEach((booking) => {
        booking.hidden = !hasMerch;
      });

      document.querySelectorAll('[data-pitb-cart-page], cart-items.pitb-cart-page').forEach((page) => {
        page.classList.toggle('is-empty', !hasMerch);
      });

      const cartFooter = document.getElementById('main-cart-footer');
      if (cartFooter) cartFooter.classList.toggle('is-empty', !hasMerch);

      document.querySelectorAll('.cart-count-bubble').forEach((bubble) => {
        if (bubble.closest('[data-pitb-cart-fab]')) return;
        const label = bubble.querySelector('[aria-hidden="true"]');
        if (label) label.textContent = String(count);
        bubble.hidden = !hasMerch;
        bubble.style.display = hasMerch ? '' : 'none';
      });
    } catch (_) {
      /* keep server-rendered count */
    }
  };

  const changeLine = async (key, quantity) => {
    const res = await pitbCartFetch(routes.change, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok || data.status) throw new Error(data.description || data.message || 'cart change failed');
    return data;
  };

  const addBookingVariant = async (variantId, quantity) => {
    const qty = Number(quantity) || 1;
    const postAdd = async (items) => {
      const res = await pitbCartFetch(routes.add, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      const data = await res.json().catch(() => ({}));
      return { res, data };
    };

    // Ticket Spot variants often reject extra line properties (422).
    let { res, data } = await postAdd([{ id: Number(variantId), quantity: qty }]);

    if ((!res.ok || data.status) && qty > 1) {
      ({ res, data } = await postAdd([{ id: Number(variantId), quantity: 1 }]));
      if (res.ok && !data.status) {
        const cart = await fetchCart();
        const line = (cart.items || []).find((item) => String(item.variant_id) === String(variantId));
        if (line) {
          try {
            await changeLine(line.key, qty);
          } catch (_) {
            /* keep qty 1 if Ticket Spot caps quantity */
          }
        }
        return data;
      }
    }

    if (!res.ok || data.status) {
      throw new Error(data.description || data.message || 'Could not add booking ticket');
    }
    return data;
  };

  const addFeeVariant = addBookingVariant;

  const attendeesFromUi = () => 1;

  const pitbCartFetch = (url, options = {}) => fetch(url, options);

  /**
   * Keep fee only while other products exist.
   * Auto-add Ticket Spot entry pass to the cart when merch + timeslot are set.
   * Only-fee carts are cleared.
   */
  const syncEntryFeeWithCart = (opts = {}) => {
    if (opts.showLoading) setFeeLoading(true);
    const run = async () => {
      try {
        return await runFeeSync({
          addIfMissing: opts.addIfMissing !== false,
          attendeesOverride: opts.attendeesOverride,
          cart: opts.cart || null,
        });
      } finally {
        hideFeeLoading();
      }
    };
    syncChain = syncChain.then(run, run);
    return syncChain;
  };

  const isSelfCollect = () => {
    const page = document.querySelector('[data-pitb-cart-page]');
    if (page && page.getAttribute('data-pitb-collection') === 'self_collect') return true;
    const attrs = (lastKnownCart && lastKnownCart.attributes) || {};
    return String(attrs.pitb_collection_method || '') === 'self_collect';
  };

  const cartHasBookingTicket = () => {
    if (isSelfCollect()) {
      if (lastKnownCart && (lastKnownCart.items || []).some(isSelfCollectItem)) return true;
      return document.querySelector('[data-pitb-self-collect-line]') !== null;
    }
    return cartHasFee();
  };

  const syncBookingTicketForMode = async ({ cart, items, addIfMissing, changed: priorChanged }) => {
    const slot = currentSlot(cart);
    const date = currentPickupDate(cart);
    const selfCollect = isSelfCollect();
    const bookingLines = items.filter(selfCollect ? isSelfCollectItem : isFeeItem);
    const targetId = slot && date
      ? selfCollect
        ? variantIdForSelfCollectSlot(slot, date)
        : variantIdForSlot(slot, date)
      : '';

    if (!targetId) {
      let removed = false;
      for (const line of bookingLines) {
        await changeLine(line.key, 0);
        removed = true;
      }
      if (removed) await refreshCartUi();
      return {
        cart: removed ? await fetchCart() : cart,
        removedFee: removed || priorChanged,
        addedFee: false,
      };
    }

    const correct = bookingLines.find((line) => String(line.variant_id) === String(targetId));
    const wrong = bookingLines.filter((line) => String(line.variant_id) !== String(targetId));
    let changed = false;

    for (const line of wrong) {
      await changeLine(line.key, 0);
      changed = true;
    }

    if (!correct && addIfMissing) {
      await addBookingVariant(targetId, 1);
      if (!selfCollect) updateFeeQtyLabels(1);
      await refreshCartUi();
      const nextCart = await fetchCart();
      if (window.PITBBooking && typeof window.PITBBooking.noteCart === 'function') {
        window.PITBBooking.noteCart(nextCart);
      }
      if (window.PITBBooking && typeof window.PITBBooking.syncCheckoutGate === 'function') {
        window.PITBBooking.syncCheckoutGate();
      }
      return { cart: nextCart, addedFee: true, removedFee: wrong.length > 0 || priorChanged };
    }

    if (correct && Number(correct.quantity) !== 1) {
      await changeLine(correct.key, 1);
      if (!selfCollect) updateFeeQtyLabels(1);
      await refreshCartUi();
      const nextCart = await fetchCart();
      if (window.PITBBooking && typeof window.PITBBooking.noteCart === 'function') {
        window.PITBBooking.noteCart(nextCart);
      }
      if (window.PITBBooking && typeof window.PITBBooking.syncCheckoutGate === 'function') {
        window.PITBBooking.syncCheckoutGate();
      }
      return { cart: nextCart, addedFee: false, removedFee: wrong.length > 0 || priorChanged };
    }

    if (correct && !selfCollect) updateFeeQtyLabels(1);
    if (changed) await refreshCartUi();
    return { cart, removedFee: wrong.length > 0 || priorChanged, addedFee: false };
  };

  const runFeeSync = async ({ addIfMissing = false, attendeesOverride = null, cart: seedCart = null } = {}) => {
    let cart = seedCart && Array.isArray(seedCart.items) ? seedCart : null;
    if (cart) {
      lastKnownCart = cart;
      if (window.PITBBooking && typeof window.PITBBooking.noteCart === 'function') {
        window.PITBBooking.noteCart(cart);
      }
    } else {
      cart = await fetchCart();
    }
    let items = cart.items || [];
    let changed = false;

    const oppositeLines = isSelfCollect()
      ? items.filter(isFeeItem)
      : items.filter(isSelfCollectItem);
    for (const line of oppositeLines) {
      await changeLine(line.key, 0);
      changed = true;
    }
    if (changed) {
      await refreshCartUi();
      cart = await fetchCart();
      items = cart.items || [];
    }

    const fees = items.filter(isFeeItem);
    const others = items.filter((item) => !isFeeItem(item) && !isSelfCollectItem(item));

    if (others.length === 0) {
      const bookingLines = items.filter((item) => isFeeItem(item) || isSelfCollectItem(item));
      for (const line of bookingLines) {
        await changeLine(line.key, 0);
      }
      if (bookingLines.length) await refreshCartUi();
      return {
        cart: bookingLines.length ? await fetchCart() : cart,
        removedFee: bookingLines.length > 0,
        addedFee: false,
      };
    }

    if (isSelfCollect()) {
      for (const fee of fees) {
        await changeLine(fee.key, 0);
        changed = true;
      }
      if (changed) {
        await refreshCartUi();
        cart = await fetchCart();
        items = cart.items || [];
      }
      return syncBookingTicketForMode({ cart, items, addIfMissing, changed });
    }

    return syncBookingTicketForMode({ cart, items, addIfMissing, changed });
  };

  /**
   * Fast Visit ↔ Self-collect switch: one cart/update clears booking tickets + attrs.
   * Avoids sequential changeLine + duplicate /cart.js + full fee sync.
   */
  const applyCollectionSwitch = async (method, attributes = {}) => {
    const nextMethod = method === 'self_collect' ? 'self_collect' : 'event';
    // Immediate totals update — do not wait for date/timeslot.
    syncEstimatedTotals(nextMethod);

    const cart =
      lastKnownCart && Array.isArray(lastKnownCart.items) ? lastKnownCart : await fetchCart();
    const updates = {};
    (cart.items || []).forEach((item) => {
      if (isFeeItem(item) || isSelfCollectItem(item)) {
        updates[item.key] = 0;
      }
    });

    const body = {
      attributes: {
        pitb_collection_method: nextMethod,
        'Collection method':
          nextMethod === 'self_collect' ? 'Self-collect Only' : 'Visit the Event',
        pitb_pickup_date: '',
        pitb_timeslot: '',
        'Pickup date': '',
        'Pickup timeslot': '',
        ...attributes,
      },
    };
    if (Object.keys(updates).length) body.updates = updates;

    const res = await pitbCartFetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    const next = await res.json().catch(() => ({}));
    if (res.ok && next && Array.isArray(next.items)) {
      lastKnownCart = next;
      if (window.PITBBooking && typeof window.PITBBooking.noteCart === 'function') {
        window.PITBBooking.noteCart(next);
      }
    }

    if (Object.keys(updates).length) {
      await refreshCartUi();
    } else {
      await syncVisibleCartCount();
    }
    syncEstimatedTotals(nextMethod);
    return next && Array.isArray(next.items) ? next : cart;
  };

  // Merch qty changes must not re-run fee sync — that races Dawn and leaves the price spinner on.

  const cartHasFee = () => {
    if (lastKnownCart && (lastKnownCart.items || []).some(isFeeItem)) return true;
    return document.querySelector('[data-pitb-entry-fee-line]') !== null;
  };

  const eventElement = (event) => {
    const node = event && event.target;
    if (!node) return null;
    if (typeof node.closest === 'function') return node;
    const parent = node.parentElement;
    return parent && typeof parent.closest === 'function' ? parent : null;
  };

  const closestFromEvent = (event, selector) => {
    const el = eventElement(event);
    return el ? el.closest(selector) : null;
  };

  const isReserveTrigger = (el) => {
    if (!el || !el.closest) return false;
    return Boolean(
      el.closest('[data-pitb-entry-fee]') ||
        el.closest('a[href="#pitb-tickets"]') ||
        el.closest('#pitb-tickets a.pitb-pill--yellow') ||
        el.closest('button[name="checkout"]') ||
        el.closest('#CartDrawer-Checkout') ||
        el.closest('a[href="/checkout"]') ||
        el.closest('a[href*="/checkout"]')
    );
  };

  const goCheckoutWithFee = async () => {
    if (isCloseState()) return;
    const selfCollect = isSelfCollect();
    const slot = currentSlot();
    const date = currentPickupDate();
    if (!selfCollect && (!date || !slot)) {
      if (window.PITBBooking && typeof window.PITBBooking.syncCheckoutGate === 'function') {
        window.PITBBooking.syncCheckoutGate();
      }
      return;
    }
    if (selfCollect && (!date || !slot)) {
      if (window.PITBBooking && typeof window.PITBBooking.syncCheckoutGate === 'function') {
        window.PITBBooking.syncCheckoutGate();
      }
      return;
    }

    setCheckoutLoading(true);
    if (window.PITBCheckoutAuth && typeof window.PITBCheckoutAuth.beginNavigate === 'function') {
      window.PITBCheckoutAuth.beginNavigate();
    }

    try {
      const result = await syncEntryFeeWithCart({ addIfMissing: true, showLoading: true });
      const cart = result.cart || (await fetchCart());
      const items = cart.items || [];
      const hasMerch = items.some((item) => !isFeeItem(item) && !isSelfCollectItem(item));
      const hasPass = selfCollect ? items.some(isSelfCollectItem) : items.some(isFeeItem);
      if (!hasMerch) {
        window.alert('Add a preorder item to checkout.');
        if (window.PITBCheckoutAuth && typeof window.PITBCheckoutAuth.cancelNavigate === 'function') {
          window.PITBCheckoutAuth.cancelNavigate();
        }
        setCheckoutLoading(false);
        return;
      }
      if (!hasPass) {
        window.alert(
          selfCollect
            ? 'Could not add the self-collect scheduling ticket. Please choose your date and timeslot again.'
            : 'Could not add The First Fan SG Popup entry pass. Please try again.'
        );
        if (window.PITBCheckoutAuth && typeof window.PITBCheckoutAuth.cancelNavigate === 'function') {
          window.PITBCheckoutAuth.cancelNavigate();
        }
        setCheckoutLoading(false);
        return;
      }
    } catch (_) {
      window.alert(
        selfCollect
          ? 'Could not add the self-collect scheduling ticket. Please choose your date and timeslot again.'
          : 'Could not add The First Fan SG Popup entry pass. Please try again.'
      );
      if (window.PITBCheckoutAuth && typeof window.PITBCheckoutAuth.cancelNavigate === 'function') {
        window.PITBCheckoutAuth.cancelNavigate();
      }
      setCheckoutLoading(false);
      return;
    }

    setCheckoutLoading(true);
    if (window.PITBCheckoutAuth) {
      window.PITBCheckoutAuth.proceedToCheckout('/checkout');
      return;
    }
    window.location.href = '/checkout';
  };

  document.addEventListener(
    'click',
    (event) => {
      const target = eventElement(event);
      if (!isReserveTrigger(target)) return;
      if (isCloseState()) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      const checkoutBtn =
        target.closest('button[name="checkout"]') || target.closest('#CartDrawer-Checkout');
      const anchor = target.closest('a');

      if (checkoutBtn) {
        // pitb-booking-v2 owns checkout clicks when present (avoids double submit).
        if (window.PITBBooking) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        if (
          (window.PITBCheckoutAuth &&
            typeof window.PITBCheckoutAuth.isNavigating === 'function' &&
            window.PITBCheckoutAuth.isNavigating()) ||
          checkoutBtn.disabled ||
          checkoutBtn.classList.contains('loading') ||
          checkoutBtn.getAttribute('aria-disabled') === 'true'
        ) {
          if (window.PITBBooking && typeof window.PITBBooking.syncCheckoutGate === 'function') {
            window.PITBBooking.syncCheckoutGate();
          }
          return;
        }
        if (window.PITBCheckoutAuth && !window.PITBCheckoutAuth.canProceedToCheckout()) {
          window.PITBCheckoutAuth.redirectToLogin();
          return;
        }
        const ready =
          window.PITBBooking && typeof window.PITBBooking.checkoutReadiness === 'function'
            ? window.PITBBooking.checkoutReadiness()
            : { ok: true, reason: '' };
        if (!ready.ok) {
          if (window.PITBBooking && typeof window.PITBBooking.syncCheckoutGate === 'function') {
            window.PITBBooking.syncCheckoutGate();
          }
          return;
        }
        goCheckoutWithFee();
        return;
      }

      if (!anchor) return;

      const href = anchor.getAttribute('href') || '';
      const isCartChange = /\/cart\/change\b/i.test(href);
      const isCartRemoveLink = Boolean(anchor.closest('cart-remove-button'));

      // Dawn remove links are handled by cart.js updateQuantity; do not intercept.
      if (isCartChange || isCartRemoveLink) return;

      const isHash = href.startsWith('#') || href === '';
      const isCheckout = href.includes('/checkout');
      const isCart = href.includes('/cart');
      const isExternal = /^https?:\/\//i.test(href);
      const isEntryReserve = anchor.hasAttribute('data-pitb-entry-reserve');

      if (!(anchor.hasAttribute('data-pitb-entry-fee') || isCheckout || isCart)) return;
      if (isHash && !anchor.hasAttribute('data-pitb-entry-fee')) return;

      if (isEntryReserve) {
        const slot = currentSlot();
        const remaining =
          window.PITBBooking && typeof window.PITBBooking.remainingForSlot === 'function'
            ? window.PITBBooking.remainingForSlot(slot)
            : 1;
        if (!slot || remaining <= 0) {
          event.preventDefault();
          event.stopPropagation();
          const picker = document.querySelector('#pitb-tickets [data-pitb-booking], [data-pitb-booking]');
          if (picker) picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
          if (window.PITBBooking && typeof window.PITBBooking.syncCheckoutGate === 'function') {
            window.PITBBooking.syncCheckoutGate();
          }
          return;
        }
      }

      event.preventDefault();
      event.stopPropagation();

      if (isExternal) {
        window.open(href, '_blank', 'noopener');
        return;
      }

      if (isCheckout) {
        goCheckoutWithFee();
        return;
      }

      syncEntryFeeWithCart({ addIfMissing: true })
        .then(() => {
          if (isHash && href !== '#') {
            const node = document.querySelector(href);
            if (node) node.scrollIntoView({ behavior: 'smooth', block: 'start' });
            else window.location.href = routes.cart;
            return;
          }
          window.location.href = href || routes.cart;
        })
        .catch(() => {
          window.location.href = href || routes.cart;
        });
    },
    true
  );

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (isCloseState()) {
      const isAddForm =
        form.getAttribute('action') === routes.add ||
        form.getAttribute('action') === `${routes.add}.js` ||
        form.getAttribute('action') === '/cart/add' ||
        form.getAttribute('action') === '/cart/add.js' ||
        form.matches('[action*="/cart/add"]');
      const isCheckoutForm = Boolean(event.submitter && event.submitter.getAttribute('name') === 'checkout');
      if (isAddForm || isCheckoutForm) {
        event.preventDefault();
        return;
      }
    }
    const goingCheckout = event.submitter && event.submitter.getAttribute('name') === 'checkout';
    if (!goingCheckout) return;
    event.preventDefault();
    if (
      (window.PITBCheckoutAuth &&
        typeof window.PITBCheckoutAuth.isNavigating === 'function' &&
        window.PITBCheckoutAuth.isNavigating()) ||
      (event.submitter &&
        (event.submitter.disabled || event.submitter.classList.contains('loading')))
    ) {
      return;
    }
    goCheckoutWithFee();
  });

  document.addEventListener(
    'click',
    (event) => {
      const emptyCart = closestFromEvent(
        event,
        '[data-pitb-cart-btn].is-empty, .pitb-cart-fab.is-empty'
      );
      if (!emptyCart) return;
      event.preventDefault();
      event.stopPropagation();
    },
    true
  );

  // Auto-add the Ticket Spot pass to the cart whenever merch + timeslot exist.
  const ensurePassInCart = () => {
    if (isCloseState()) return;
    syncEntryFeeWithCart({ addIfMissing: true }).catch(() => hideFeeLoading());
  };

  let cartPrefetched = false;
  const prefetchCartPage = () => {
    if (cartPrefetched) return;
    cartPrefetched = true;
    if ('fetch' in window) {
      fetch(routes.cart, { credentials: 'same-origin', priority: 'low' }).catch(() => {});
    }
  };

  document.addEventListener(
    'pointerenter',
    (event) => {
      const link = closestFromEvent(
        event,
        '[data-pitb-cart-btn], [data-pitb-cart-href], .pitb-cart-fab'
      );
      if (link) prefetchCartPage();
    },
    { passive: true }
  );

  document.addEventListener(
    'focusin',
    (event) => {
      const link = closestFromEvent(
        event,
        '[data-pitb-cart-btn], [data-pitb-cart-href], .pitb-cart-fab a'
      );
      if (link) prefetchCartPage();
    },
    { passive: true }
  );

  document.addEventListener(
    'click',
    (event) => {
      const link = closestFromEvent(
        event,
        '[data-pitb-cart-btn]:not(.is-empty), [data-pitb-cart-href]:not(.is-empty), .pitb-cart-fab:not(.is-empty) a'
      );
      if (!link) return;
      const href = link.getAttribute('href') || '';
      if (href.includes('/checkout')) return;
      link.classList.add('is-navigating');
      link.setAttribute('aria-busy', 'true');
      const fab = link.closest('.pitb-cart-fab-wrap');
      if (fab) fab.classList.add('is-navigating');
    },
    true
  );

  const isCartPage = () => Boolean(document.querySelector('[data-pitb-cart-page]'));

  const setCartPageSyncing = (on) => {
    document.querySelectorAll('[data-pitb-cart-page], cart-items.pitb-cart-page').forEach((page) => {
      page.classList.toggle('is-syncing', Boolean(on));
    });
    document.querySelectorAll('[data-pitb-cart-loading]').forEach((el) => {
      el.hidden = !on;
      el.setAttribute('aria-hidden', on ? 'false' : 'true');
      el.setAttribute('aria-busy', on ? 'true' : 'false');
    });
  };

  const removeInviteOnlyLines = async () => {
    const rows = Array.from(
      document.querySelectorAll(
        '[data-pitb-cart-page] [data-pitb-line-blocked="invite"][data-pitb-line-key]'
      )
    );
    if (!rows.length) return false;

    const updates = {};
    rows.forEach((row) => {
      const key = row.getAttribute('data-pitb-line-key');
      if (key) updates[key] = 0;
    });
    if (!Object.keys(updates).length) return false;

    const res = await fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates }),
    });
    if (!res.ok) return false;

    await refreshCartUi();
    return true;
  };

  const bootCartPage = () => {
    setCartPageSyncing(true);
    const page = document.querySelector('[data-pitb-cart-page]');
    const method =
      page && page.getAttribute('data-pitb-collection') === 'self_collect' ? 'self_collect' : 'event';
    syncEstimatedTotals(method);
    const safety = setTimeout(() => setCartPageSyncing(false), 4500);
    const inviteClean = removeInviteOnlyLines().catch(() => false);
    const feeReady = inviteClean
      .then(() => syncEntryFeeWithCart({ addIfMissing: true }))
      .then(() => syncVisibleCartCount())
      .then(() => syncEstimatedTotals(method))
      .catch(() => syncVisibleCartCount());
    const calendarReady =
      window.PITBBookingReady ||
      (window.PITBBooking && window.PITBBooking.whenReady) ||
      Promise.resolve();
    Promise.all([feeReady, calendarReady])
      .catch(() => {})
      .finally(() => {
        clearTimeout(safety);
        setCartPageSyncing(false);
        const latest =
          document.querySelector('[data-pitb-cart-page]')?.getAttribute('data-pitb-collection') ===
          'self_collect'
            ? 'self_collect'
            : 'event';
        syncEstimatedTotals(latest);
      });
  };

  const bootVisibleCartCount = () => {
    disableAddToCartWhenClosed();
    syncSlotForms();
    if (isCartPage()) {
      bootCartPage();
      return;
    }
    ensurePassInCart();
    syncVisibleCartCount();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootVisibleCartCount);
  } else {
    bootVisibleCartCount();
  }

  document.addEventListener('cart:updated', () => {
    setTimeout(ensurePassInCart, 120);
    setTimeout(() => syncVisibleCartCount(), 150);
  });

  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      setTimeout(ensurePassInCart, 120);
      setTimeout(() => syncVisibleCartCount(), 150);
    });
  }

  window.PITBEntryFee = {
    sync: syncEntryFeeWithCart,
    ensure: (opts = {}) => syncEntryFeeWithCart({ ...opts, addIfMissing: true }),
    applyCollectionSwitch,
    syncEstimatedTotals,
    showLoading: () => setFeeLoading(true),
    hideLoading: () => hideFeeLoading(),
    setCartPageSyncing,
    setCheckoutLoading,
    syncVisibleCartCount,
    visibleCartCount,
    isFeeItem,
    isSelfCollectItem,
    syncAttendees: async (attendeesOverride, options = {}) => {
      const qty = Number(attendeesOverride);
      await syncEntryFeeWithCart({
        addIfMissing: true,
        showLoading: options.showLoading !== false,
        cart: options.cart || null,
        attendeesOverride: Number.isFinite(qty) && qty > 0 ? qty : attendeesFromUi(),
      });
      await syncVisibleCartCount();
    },
    label: cfg.label || 'The First Fan SG Popup Entry Fee',
    variantId: Number(VARIANT_ID),
    properties: PROPERTIES,
    syncSlotForms,
    checkout: goCheckoutWithFee,
  };
})();
